import React from 'react'

import Paper from 'components/Paper'
import UserPhoto from 'components/UserPhoto'

import { withStyles, createStyles, WithStyles, Typography, Theme } from '@material-ui/core'

import { IUser } from 'protos'

interface Props {
  friends: Array<IUser>
  onClick: (friend: IUser) => void
}

const styles = (theme: Theme) => createStyles({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
    backgroundColor: theme.palette.grey['200'],
  },
  friend: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: theme.spacing(),
    cursor: 'pointer',
  }
})

type InjectedProps = Props & WithStyles<typeof styles>

const FriendSlideshow: React.SFC<InjectedProps> = ({ friends, onClick, classes }) => (
  <Paper className={classes.root}>
    {friends
      .map((friend, i) => (
        <div key={i} className={classes.friend} onClick={() => { onClick(friend) }}>
          <UserPhoto src={friend.photoUrl!} />
          <Typography variant="h3" color="inherit">{friend.name}</Typography>
        </div>
      ))
    }
  </Paper>
)

export default withStyles(styles)(FriendSlideshow)
